import React from 'react'
import { useSelector } from 'react-redux'
import { InfoOutlined } from '@material-ui/icons'

export default function InfoBlock({ children, mainColor, noIcon }) {
    const { theme } = useSelector((state) => state.main)
    
    return (
        <div
            style={{
                padding: 50,
                backgroundColor: theme.tertiary,
                borderRadius: theme.borderRadius,
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {!noIcon &&
                <div style={{ paddingRight: 50 }}>
                    <InfoOutlined fontSize='medium' htmlColor={mainColor || theme.primary}/>
                </div>
            }
            <div style={{ flex: 1 }}>
                {children}
            </div>
        </div>
    )
}
